import { useMemo } from 'react';
import { PromoCodeSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): PromoCodeSortingField => {
    switch (field) {
        case 'module.company.displayName':
            return PromoCodeSortingField.Company;

        case 'isActive':
            return PromoCodeSortingField.IsActive;

        case 'promoCode':
            return PromoCodeSortingField.PromoCode;

        case 'promoType.amount':
            return PromoCodeSortingField.PromoType;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const companySort = useMemo(
        () => (sort.field === PromoCodeSortingField.Company ? sort.orderValue : undefined),
        [sort]
    );

    const promoCodeSort = useMemo(
        () => (sort.field === PromoCodeSortingField.PromoCode ? sort.orderValue : undefined),
        [sort]
    );

    const promoTypeSort = useMemo(
        () => (sort.field === PromoCodeSortingField.PromoType ? sort.orderValue : undefined),
        [sort]
    );
    const activeSort = useMemo(
        () => (sort.field === PromoCodeSortingField.IsActive ? sort.orderValue : undefined),
        [sort]
    );

    return {
        companySort,
        promoCodeSort,
        promoTypeSort,
        activeSort,
    };
};

export default useSortOrder;
